const UserFavoritesPage = resolve => require(['@/pages/user/FavoritesPage'], resolve)
const UserProfilePage = resolve => require(['@/pages/user/ProfilePage'], resolve)
const UserCheckingAccountPage = resolve => require(['@/pages/user/CheckingAccountPage'], resolve)
const UserPublicationsPage = resolve => require(['@/pages/user/PublicationsPage'], resolve)
const UserPurchasesPage = resolve => require(['@/pages/user/PurchasesPage'], resolve)
const UserSalesPage = resolve => require(['@/pages/user/SalesPage'], resolve)
const UserFollowedUsersPage = resolve => require(['@/pages/user/FollowedUsersPage'], resolve)
const UserQuestionsPage = resolve => require(['@/pages/user/QuestionsPage'], resolve)
const PublicationPage = resolve => require(['@/pages/publicationPage'], resolve)
const CategoryPage = resolve => require(['@/pages/categoryPage'], resolve)

const titleSuffix = ' — MasPocoVendo.com'

export default [
  {
    path: '/cuenta/perfil',
    name: 'userProfile',
    component: UserProfilePage,
    meta: {
      title: 'Mi perfil' + titleSuffix,
      requiresAuth: true
    }
  },
  {
    path: '/cuenta/publicaciones',
    name: 'userPublications',
    component: UserPublicationsPage,
    meta: {
      title: 'Mis Publicaciones' + titleSuffix,
      requiresAuth: true
    }
  },
  {
    path: '/cuenta/compras',
    name: 'userPurchases',
    component: UserPurchasesPage,
    meta: {
      title: 'Mis Compras' + titleSuffix,
      requiresAuth: true
    }
  },
  {
    path: '/cuenta/ventas',
    name: 'userSales',
    component: UserSalesPage,
    meta: {
      title: 'Mis Ventas' + titleSuffix,
      requiresAuth: true
    }
  },
  {
  // Previous private URL for own publications
    path: '/cuenta/publicacion/:title?/:id',
    name: 'userPublication',
    redirect: to => {
      const { hash, params, query } = to
      return { name: 'publication', params: { title: params.title, id: params.id } }
    }
  },
  {
    path: '/cuenta/cuenta-corriente',
    name: 'userCheckingAccount',
    component: UserCheckingAccountPage,
    meta: {
      title: 'Mi Cuenta Corriente' + titleSuffix,
      requiresAuth: true
    }
  },
  {
    path: '/cuenta/seguidos',
    name: 'userFollowedUsers',
    component: UserFollowedUsersPage,
    meta: {
      title: 'Vendedores Seguidos' + titleSuffix,
      requiresAuth: true
    }
  },
  {
    path: '/cuenta/seguidos/publicaciones',
    name: 'userFollowedUserPublications',
    component: CategoryPage,
    meta: {
      title: 'Publicaciones de Vendedores Seguidos' + titleSuffix,
      requiresAuth: true
    }
  },
  {
    path: '/cuenta/preguntas/:tab',
    name: 'userQuestions',
    component: UserQuestionsPage,
    meta: {
      title: 'Mis Preguntas' + titleSuffix,
      requiresAuth: true
    }
  },
  {
    path: '/cuenta/favoritos',
    name: 'userFavorites',
    component: UserFavoritesPage,
    meta: {
      title: 'Mis Favoritos' + titleSuffix,
      requiresAuth: true
    }
  },
  {
    path: '/cuenta/republicar/:token',
    redirect: to => {
      const { hash, params, query } = to
      return { name: 'home', query: { republish_token: params.token } }
    }
  },
  {
    path: '/cuenta/eliminar/:token',
    redirect: to => {
      const { hash, params, query } = to
      return { name: 'home', query: { delete_token: params.token } }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/user.js